import 'init';

import React from 'react';
import ReactDOM from 'react-dom';

import * as singleSpa from 'single-spa';

import * as ClassicApp from 'singlespa/apps/classic';
import * as GammaApp from 'singlespa/apps/gamma';
import Interceptor from 'singlespa/interceptor';

import { Chrome } from 'views/chrome/chrome-view';

import { featureFlagClient } from 'common/lib/feature-flag-client';

// This is a "loading function" Inside of it, the import introduces a code splitting
// point. Webpack will create separate code chunks that will be lazy loaded by single-spa.
const loadGamma = () => Promise.resolve().then(() => GammaApp);
const loadClassic = () => Promise.resolve().then(() => ClassicApp);

// This is an "activity function"
// this is where we'd check for whether this is a classic or gamma url ... rather than use window location
const isGammaActive = () => Interceptor.isGammaRoute(window.location.pathname);
const isClassicActive = () => !isGammaActive();

// Register the application with single-spa
singleSpa.registerApplication('gamma', loadGamma, isGammaActive);
singleSpa.registerApplication('classic', loadClassic, isClassicActive);

// Wait for the ldclient to be ready before rendering the root component. This
// is necessary (even though we bootstrap feature flags from localStorage)
// because the ldclient will return default values for flags until after it is
// finished initializing (deferred to the next turn of the event loop).
const ldClientInitialized = featureFlagClient.client.waitForInitialization();
// Manually time the ldclient out after 10 seconds, in case something prevents
// the ldclient from properly initializing
const ldClientTimeoutThreshold = 10 * 1000;
const ldClientTimeout = new Promise((resolve, reject) => {
  setTimeout(reject, ldClientTimeoutThreshold);
});

// Race the ldclient initialization against the timeout, using .finally()
// because we don't care about the outcome.
Promise.race([ldClientInitialized, ldClientTimeout]).finally(() => {
  ReactDOM.render(<Chrome />, document.getElementById('classic'));
});



// WEBPACK FOOTER //
// ./app/scripts/entry/app.js